import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { isClient } from "@verivest/shared-components";
import { AuthenticatedAction } from "@verivest/shared-components/src/components/common/AuthenticatedAction";
import { VeriSpinner } from "@verivest/shared-components/src/components/common/loaders/VeriSpinner";
import React from "react";
import useApi from "../../../../../hooks/useApi";
import { dateToString } from "../../../../../utils/utils";
import { DownloadIcon } from "../../../../general";
import { OpportunityDocumentBoxProps } from "./OpportunityDocuments.types";

export const DocumentBox: React.FC<OpportunityDocumentBoxProps> = ({
  id,
  title,
  filename,
  date,
  ...rest
}) => {
  const api = useApi();
  const [isDownloading, setIsDownloading] = React.useState(false);
  const getFileNameExtensionExp = /(?:\.([^.]+))?$/;
  const extension = getFileNameExtensionExp.exec(filename)?.[1] || "";

  return (
    <Box>
      <AuthenticatedAction
        mt="0!important"
        onClick={async () => {
          setIsDownloading(true);
          await api.downloadDocument(id, title);
          setIsDownloading(false);
        }}
        backTo={isClient() ? window.location.href : undefined}
      >
        <Flex
          className={"px-6 py-4 bg-white cursor-pointer flex-col sm:flex-row"}
          boxShadow="2"
          borderRadius={4}
          borderColor="border.input"
          borderWidth="1px"
          {...rest}
        >
          <Flex
            justifyContent="space-between"
            className={"flex-col sm:flex-row sm:flex-grow gap-2"}
          >
            <Flex className={"flex-col sm:flex-row gap-2"}>
              <Text
                textStyle="labelXS"
                py={0}
                fontWeight="600"
                color="white"
                bg="icons.grey"
                borderRadius={4}
                px={1.5}
                lineHeight="24px"
                as="span"
                fontFamily="heading"
                className={"self-start"}
              >
                {(extension || "").toUpperCase()}
              </Text>
              <Text className={"sm:ml-4"}>{title}</Text>
            </Flex>
            <Flex className={"justify-between sm:gap-4 sm:justify-start"}>
              <Text color="text.grey">
                {dateToString(new Date(date * 1000))}
              </Text>
              <Flex>
                {!isDownloading && (
                  <Icon
                    // p="8px"
                    boxSize="20px"
                    cursor="pointer"
                    as={DownloadIcon}
                    color="brand.main"
                  />
                )}
                {isDownloading && <VeriSpinner boxSize="20px" />}
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </AuthenticatedAction>
    </Box>
  );
};
